import React from "react";

import "./EmbellishedHeading.scss";

const EmbellishedHeading = ({ children }) => {
  return <div className="embellished-heading">{children}</div>;
};

export default EmbellishedHeading;
